<template>
  <div class="recorder-container">
    <div class="image-section">
      <!-- Observe Message -->
      <div v-if="showObserveMessage" class="observe-message">
        <p>Observe the picture...</p>
      </div>

      <div v-if="!showObserveMessage && !countdown" class="prompt-section">
        <p class="prompt">{{ currentPrompt }}</p>
      </div>

      <!-- Image Display -->
      <!-- Media Display -->
      <template v-if="!showObserveMessage">
        <img
          v-if="currentMedia.type === 'image'"
          :src="currentMedia.src"
          alt="Image to describe"
          class="image-display"
          @load="onImageLoad"
        />
        <!-- <video
          v-else-if="currentMedia.type === 'video'"
          :src="currentMedia.src"
          controls
          autoplay
          muted
          playsinline
          class="image-display"
          @loadeddata="onImageLoad"
        ></video> -->
        <video
          v-else-if="currentMedia.type === 'video'"
          ref="mediaVideo"
          :src="currentMedia.src"
          controls
          autoplay
          muted
          playsinline
          class="image-display"
          @loadeddata="onImageLoad"
        />

      </template>

    </div>

    <div class="controls">
      <!-- Countdown -->
      <div v-if="countdown > 0 && !recording" class="countdown">
        <p>Get ready in: <span class="timer">{{ countdown }}</span></p>
      </div>

      <!-- Recording Controls -->
      <div v-else-if="!countdown && !recording && !loading && !showObserveMessage && !audioUrl" class="recording-controls">
        <button @click="startRecording" class="btn btn-record">
          <i class="icon-record"></i> Start Recording
        </button>
      </div>

      <!-- Recording Status -->
      <div v-else-if="recording" class="recording-status">
        <div class="status-message">
          <span class="dot"></span> Recording...
        </div>
        <button @click="stopRecording" class="btn btn-stop">
          <i class="icon-stop"></i> Stop
        </button>
      </div>

      <!-- Loading Indicator -->
      <div v-if="loading" class="loading-section">
        <div class="spinner"></div>
        <p class="loading-message">Processing your description, please wait...</p>
      </div>

      <!-- Playback and Transcription -->
      <div v-if="audioUrl && !loading" class="playback-section">
        <p v-if="transcription">
          <strong>Transcription:</strong> {{ transcription }}
        </p>
        <p v-else>
          <strong>Oops!</strong> There was an issue processing your audio. Please try again.
        </p>
        <div class="actions">
          <button @click="retryRecording" class="btn btn-retry">
            <i class="icon-retry"></i> Retry
          </button>
          <button @click="nextImage" class="btn btn-next">
            <i class="icon-next"></i> Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toRaw } from 'vue';

export default {
  props: {
  mediaList: {
    type: Array,
    required: true,
    },
    pin: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
      user_pin: null,
      showObserveMessage: true,
      countdown: 0,
      recording: false,
      audioChunks: [],
      videoChunks: [],
      observationVideoChunks: [],
      mediaRecorder: null,
      observationRecorder: null,
      audioUrl: null,
      transcription: null,
      loading: false,
      videoStream: null, // Video stream object for description
      observationStream: null, // Video stream object for observation
      eeg_observation_metadata: null,
      eeg_observation_data: null,
      eeg_response_metadata: null,
      eeg_response_data: null,

    };
  },
  computed: {
    currentMedia() {
      return this.mediaList[this.currentIndex];
    },
    currentPrompt() {
      return this.currentMedia.caption;
    },
  },
  methods: {
    restartVideoPlayback() {
  this.$nextTick(() => {
    const video = this.$refs.mediaVideo;
    if (video) {
      video.currentTime = 0;
      video.play().catch((err) => {
        console.warn('Autoplay blocked or failed:', err);
      });
    }
  });
},

    showObserveMessageThenImage() {
      this.showObserveMessage = true;
      setTimeout(() => {
        this.showObserveMessage = false;
      }, 3007);
    },
    onImageLoad() {
      this.startObservationRecording();
      this.startCountdown();
    },
    startCountdown() {
      this.countdown = 3;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
          this.stopObservationRecording();
        }
      }, 1000);

    },
    // startObservationRecording() {
    //   this.observationVideoChunks = [];
    //   navigator.mediaDevices
    //     .getUserMedia({ video: true })
    //     .then((stream) => {
    //       this.observationRecorder = new MediaRecorder(stream);
    //       this.observationRecorder.ondataavailable = (event) => {
    //         if (event.data && event.data.size > 0) {
    //           this.observationVideoChunks.push(event.data);
    //         }
    //       };
    //       this.observationRecorder.start();
    //       this.observationStream = stream; // Store the stream to stop it later
    //     })
    //     .catch((err) => console.error("Error accessing video device:", err));
    // },
    // stopObservationRecording() {
    //   if (this.observationRecorder) {
    //     this.observationRecorder.stop();
    //     if (this.observationStream) {
    //       this.observationStream.getTracks().forEach((track) => track.stop());
    //     }
    //   }
    // },

    async startObservationRecording() {
      this.observationVideoChunks = [];
      try {
        const response = await fetch("https://127.0.0.1:5120/start", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fp_title: `${this.pin.pin}_observation_${this.currentIndex}`,
          }),
        });
        if (!response.ok) throw new Error("Failed to start observation recording");
        
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.observationRecorder = new MediaRecorder(stream);
        this.observationRecorder.ondataavailable = (event) => {
          if (event.data && event.data.size > 0) {
            this.observationVideoChunks.push(event.data);
          }
        };
        this.observationRecorder.start();
        this.observationStream = stream;
      } catch (err) {
        console.error("Error starting observation recording:", err);
      }
    },
    async stopObservationRecording() {
      if (this.observationRecorder) {
        this.observationRecorder.stop();
        if (this.observationStream) {
          this.observationStream.getTracks().forEach((track) => track.stop());
        }
      }

      try {
        const response = await fetch("https://127.0.0.1:5120/stop", {
          method: "POST",
        });

        if (!response.ok) {
          throw new Error(`Failed to stop observation recording. Status: ${response.status}`);
        }

        const rawText = await response.text();
        console.log("Raw Response Text:", rawText);

        try {
          const data = JSON.parse(rawText);  // Now parse it safely
          this.eeg_observation_metadata = data.metadata;
          this.eeg_observation_data = data.csvcontent;

          console.log("EEG Metadata:", this.eeg_observation_metadata);
          console.log("EEG Data:", this.eeg_observation_data);
        } catch (parseError) {
          console.error("JSON Parsing Error:", parseError);
        }

      } catch (err) {
        console.error("Error stopping observation recording:", err);
      }
    },

    async startRecording() {
      this.restartVideoPlayback();

      this.audioChunks = [];
      this.videoChunks = [];
      this.audioUrl = null;
      try{
        const response = await fetch("https://127.0.0.1:5120/start", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fp_title: `${this.pin.pin}_response_${this.currentIndex}`,
          }),
        });

        if (!response.ok) throw new Error("Failed response to start eeg recording");
      }
      catch (err) {
        console.error("Error starting response recording:", err);
      }
      
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);
          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data && event.data.size > 0) {
              this.audioChunks.push(event.data);
              this.videoChunks.push(event.data);
            }
          };
          this.mediaRecorder.onstop = this.handleRecordingStop;
          this.mediaRecorder.start();
          this.videoStream = stream;
          this.recording = true;
        })
        .catch((err) => console.error("Error accessing media devices:", err));
    },
    async stopRecording() {
      try{
        const response = await fetch("https://127.0.0.1:5120/stop", {
          method: "POST",
        });

        if (!response.ok) throw new Error("Failed response to stop eeg recording");
        const data = await response.json(); // Parse the JSON response

        // Assign the metadata and EEG data
        this.eeg_response_metadata = data.metadata;
        this.eeg_response_data = data.csvcontent;

        console.log("EEG Metadata:", this.eeg_response_metadata);
        console.log("EEG Data:", this.eeg_response_data);
      }
      catch (err) {
        console.error("Error stopping the response recording:", err);
      }

      if (this.mediaRecorder) {
        this.mediaRecorder.stop();
        this.recording = false;

        if (this.videoStream) {
          this.videoStream.getTracks().forEach((track) => track.stop());
        }
      }
    },
    handleRecordingStop() {
      const audioBlob = new Blob(this.audioChunks, { type: "audio/webm" });
      const videoBlob = new Blob(this.videoChunks, { type: "video/webm" });
      const observationVideoBlob = new Blob(this.observationVideoChunks, { type: "video/webm" });

      this.audioUrl = URL.createObjectURL(audioBlob);

      this.uploadAndTranscribe(audioBlob, videoBlob, observationVideoBlob);
    },
    async uploadAndTranscribe(audioBlob, videoBlob, observationVideoBlob) {
      this.loading = true;
      const formData = new FormData();

      formData.append("audio", audioBlob, `recording_${this.currentIndex}.webm`);
      formData.append("video", videoBlob, `video_${this.currentIndex}.webm`);
      formData.append("observationVideo", observationVideoBlob, `observation_${this.currentIndex}.webm`);
      formData.append("eeg_observation_metadata", JSON.stringify(toRaw(this.eeg_observation_metadata)));
      formData.append("eeg_observation_data", JSON.stringify(toRaw(this.eeg_observation_data)));
      formData.append("eeg_response_metadata", JSON.stringify(toRaw(this.eeg_response_metadata)));
      formData.append("eeg_response_data", JSON.stringify(toRaw(this.eeg_response_data)));
      formData.append("pin", this.user_pin);
      formData.append("imageIndex", this.currentIndex);
      formData.append("media_path", this.currentImage);

      try {
        const response = await fetch("https://firefly-study.athenarc.gr/upload-and-transcribe", {
          method: "POST",
          body: formData,
        });

        const data = await response.json();
        if (data.success) {
          this.transcription = data.transcription;
        } else {
          console.error("Error in transcription response:", data.error);
          this.transcription = null;
        }
      } catch (err) {
        console.error("Error uploading or transcribing:", err);
        this.transcription = null;
      } finally {
        this.loading = false;
      }
    },
    retryRecording() {
      this.audioUrl = null;
      this.transcription = null;
      this.startCountdown();
      this.restartVideoPlayback();

    },
    nextImage() {
      if (this.currentIndex < this.mediaList.length - 1) {
        this.currentIndex++;
        this.audioUrl = null;
        this.transcription = null;
        this.showObserveMessageThenImage();
      } else {
        alert("All images processed!");
      }
    },
  },
  mounted() {
    this.user_pin = this.pin.pin;
    this.showObserveMessageThenImage();
  },
};
</script>



  
  <style scoped>
  /* Container */
  .recorder-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Arial, sans-serif;
    padding: 20px;
  }
  
  /* Image Section */
  .image-section {
    position: relative;
    width: 80%;
    max-width: 500px;
  }
  
  .image-display {
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  
  .observe-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5em;
    color: #fff;
    background: rgba(0, 0, 0, 0.8);
    padding: 15px 20px;
    border-radius: 8px;
    text-align: center;
  }
  
  /* Controls */
  .controls {
    margin-top: 20px;
    text-align: center;
  }
  
  .countdown .timer {
    font-weight: bold;
    color: #007bff;
  }
  
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    font-size: 1.2em;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-record {
    background-color: #28a745;
    color: white;
  }
  
  .btn-stop {
    background-color: #dc3545;
    color: white;
  }
  
  .btn-retry {
    background-color: #ff7a06;
    color: white;
  }
  
  .btn-next {
    background-color: #1a00ff;
    color: white;
  }
  
  /* Recording Status */
  .recording-status .dot {
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 8px;
    animation: blink 1s infinite;
  }
  
  /* Loading Section */
  .loading-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
  }
  
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  .loading-message {
    font-size: 1.2em;
    margin-top: 10px;
    color: #555;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .prompt-section {
    margin: 15px 0;
    text-align: center;
    }

  .prompt {
    font-size: 1.2em;
    font-weight: bold;
    color: #333;
    background-color: #f9f9f9;
    padding: 10px 15px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  </style>
  